import { MrbBaseRouteStore } from "mrb/core";
import { LoadioAlbumService, LoadioAlbumTrackFileStreamService } from "common/services";

class LoadioAlbumTrackListRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);
        this.loadioAlbumService = this.rootStore.createApplicationService(LoadioAlbumService);
        this.loadioAblumTrackFileStreamService = this.rootStore.createApplicationService(
            LoadioAlbumTrackFileStreamService
        );
    }

    async getAlbum(id) {
        const response = await this.loadioAlbumService.get(id, { embed: "artist" });
        return response.data;
    }

    async getSongs(albumId, params) {
        const response = await this.loadioAlbumService.getAllSongs(albumId, params);
        return response.data;
    }

    async editAlbumTrackTitle(id, resource) {
        await this.loadioAlbumService.editAlbumTrackTitle(id, resource);
    }
}

export default LoadioAlbumTrackListRouteStore;
